import { FormActions } from "../../components/common/FormActions";
import { StatusTags } from "../../components/common/registerUtils";
import {
  API_GENERATE_MERCHANT_PAYMENT_CODE,
  API_MERCHANT_CODES,
} from "../../utils/apis";
import { CAN_ADMIN, REACTIVATE } from "../../utils/constants";
import {
  createDeactivateAction,
  createViewEdit,
  formatDateTime,
  getForm,
  getRegister,
  itemExists,
  useGetUserPermissions,
} from "../../utils/helpers";
import { URL_MERCHANT_CODES } from "../../utils/urls";
import { IFormSection } from "../../types/common";
import { useParams } from "react-router-dom";

const url = URL_MERCHANT_CODES;

// REGISTER
export const useMerchantCodes = () => {
  const { id } = useParams<{ id?: string }>();
  const permissions = useGetUserPermissions();
  const tableColumns = () => [
    {
      id: "code",
      header: "Merchant Code",
      filter: {},
    },
    ...(itemExists(permissions, [CAN_ADMIN])
      ? [
          {
            id: "merchant_owner",
            header: "Parent Merchant",
            filter: {},
          },
        ]
      : []),
    {
      id: "alias",
      header: "Alias",
      filter: {
        type: "text",
      },
    },
    {
      id: "status",
      header: "Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        status: <StatusTags status={item?.status} />,
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions
            actions={[
              ...createViewEdit(url, item?.id),
              ...(item?.status === "Inactive"
                ? [
                    {
                      label: REACTIVATE,
                      deleteUrl: `${API_MERCHANT_CODES}${item?.id}/reactivate/`,
                      applicationId: item?.id,
                    },
                  ]
                : [
                    createDeactivateAction(
                      `${API_MERCHANT_CODES}${item?.id}/deactivate/`,
                      item?.code,
                      {
                        // is_active: false,
                      },
                      {
                        // showReasonField: true,
                        method: "POST",
                      },
                    ),
                  ]),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Codes Details",
          fields: {
            ...item,
            status: <StatusTags status={item?.status} />,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  const endpoint = `${API_MERCHANT_CODES}${id}/logs/`;
  const formRoute = getForm(URL_MERCHANT_CODES);

  return { tableData, tableColumns, viewData, endpoint, formRoute };
};

// FORM
export const useMerchantCodeForm = ({ id }) => {
  const isEdit = !!id;
  const sections: IFormSection[] = [
    {
      title: "Merchant Code Details",
      fields: [
        {
          field_name: "alias",
          type: "text",
          props: { required: !isEdit },
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  function onSubmit(payload: any, id: string | number) {
    if (id) {
      return {
        id,
        api: `${API_GENERATE_MERCHANT_PAYMENT_CODE}`,
        params: {
          ...payload,
        },
      };
    }

    //   CREATE
    return {
      api: `${API_GENERATE_MERCHANT_PAYMENT_CODE}`,
      params: {
        ...payload,
      },
    };
  }

  return { sections, redirect, onSubmit };
};
